<!-- START TEAM-->
<section class="section bg-light" id="team">
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-lg-12">
            <h3 class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0"
                style="font-size: 45px; color: rgb(0, 0, 0) !important;">E<strong
                    style="font-family: 'Montserrat-Regular', sans-serif;color: rgb(0, 0, 0);">VENTOS</strong></h3>
                <!-- <h3 class="title"> <span class="fw-bold">EVENTOS</span></h3> -->
                <p class="pdtxt text-muted mt-3 title-subtitle mx-auto">No dejes que la oportunidad pase de largo. <br />Regístrate en los eventos que te inspiran.<br/><br /> <strong>¡Da clic en la imágen para acceder al registro y bases del concurso!</strong></p>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/quien-quiere-ser-gregoriano/index.html" target="_blank"><img src="./assets/images/agenda/1.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/concurso-pintura/index.html" target="_blank"> <img src="./assets/images/agenda/2.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/voces-gregoriana/index.html" target="_blank"><img src="./assets/images/agenda/3.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div> 
            </div>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                 <a href="https://sangregorio.edu.ec/bandasestudiantilesusgp/index.html" target="_blank"><img src="./assets/images/agenda/4.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/festival-dj/index.html" target="_blank"><img src="./assets/images/agenda/5.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLScoo2JHmHBzyy1QiNhst1D0EntCsbPzhRbCNG9bbEhw8Q-nsw/viewform" target="_blank"> <img src="./assets/images/agenda/6.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <!-- <ng-template #contenido1 let-modal>
                <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                    style="padding:0% !important;">
                    <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                        <div class="modal-content" style="padding:0% !important;">
            
                            <div class="modal-body" style="padding:0% !important;">
                                <img src="./assets/images/agenda/6.jpeg" width="100%" alt="">
                            </div>
            
                        </div>
                    </div>
                </div>
            </ng-template> -->
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a (click)="modal.open(contenido2)"> <img src="./assets/images/agenda/7.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <ng-template #contenido2 let-modal>
                <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                    style="padding:0% !important;">
                    <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                        <div class="modal-content" style="padding:0% !important;">
            
                            <div class="modal-body" style="padding:0% !important;">
                                <img src="./assets/images/agenda/7.jpeg" width="100%" alt="">
                            </div>
            
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/concurso-dibujo/index.html" target="_blank"> <img
                            src="./assets/images/agenda/8.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/talentos-en-formacion/index.html" target="_blank"> <img src="./assets/images/agenda/9.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                    <a (click)="modal.open(contenido5)"><img src="./assets/images/agenda/10.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <ng-template #contenido5 let-modal>
                <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                    style="padding:0% !important;">
                    <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                        <div class="modal-content" style="padding:0% !important;">
            
                            <div class="modal-body" style="padding:0% !important;">
                                <img src="./assets/images/agenda/10.jpeg" width="100%" alt="">
                            </div>
            
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/concurso-cosplay/index.html" target="_blank"> <img src="./assets/images/agenda/11.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <ng-template #contenido5 let-modal>
                <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                    style="padding:0% !important;">
                    <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                        <div class="modal-content" style="padding:0% !important;">
            
                            <div class="modal-body" style="padding:0% !important;">
                                <img src="./assets/images/agenda/11.jpeg" width="100%" alt="">
                            </div>
            
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="col-lg-4" style="margin-bottom: 3%;">
                <div class="">
                <a href="https://sangregorio.edu.ec/expocomunicarte2023/eventos/concurso-kpop/index.html" target="_blank"> <img src="./assets/images/agenda/12.jpeg" alt="" class="img-fluid  mx-auto d-block"></a>
                </div>
            </div>
            <ng-template #contenido5 let-modal>
                <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                    style="padding:0% !important;">
                    <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                        <div class="modal-content" style="padding:0% !important;">
            
                            <div class="modal-body" style="padding:0% !important;">
                                <img src="./assets/images/agenda/12.jpeg" width="100%" alt="">
                            </div>
            
                        </div>
                    </div>
                </div>
            </ng-template>
            
        </div>
    </div>
</section>
<!-- END TEAM -->